import React, { useEffect } from "react";
import helpers from "helpers/base";
import { CHAPTERS, DEVICES } from "../../constants/literary_devices";

// TODO: Move all this into the parent component since it's not really adding much
const QueryParamsControls = ({ filterOptions, setViewMode, setFilterBy }) => {
  const findFilterByOption = (filterByOption) =>
    filterOptions.find((option) => option.value === filterByOption);

  const setParamFilters = (_) => {
    const viewModeParam = helpers.getQueryParam("viewMode")?.toLowerCase();
    const filterByParam = helpers.getQueryParam("filterBy")?.toLowerCase();

    if (!viewModeParam && !filterByParam) {
      setViewMode(DEVICES, false);
      setFilterBy(filterOptions[0], false);
    }
    if (viewModeParam) {
      setViewMode(viewModeParam, false);
    }

    if (findFilterByOption(filterByParam)) {
      setFilterBy(findFilterByOption(filterByParam), false);
    }
  };

  useEffect(() => {
    window.addEventListener("popstate", setParamFilters);
    return () => window.removeEventListener("popstate", setParamFilters);
  }, []);

  useEffect(() => {
    const viewModeParam = helpers.getQueryParam("viewMode")?.toLowerCase();
    const filterByParam = helpers.getQueryParam("filterBy")?.toLowerCase();
    if (viewModeParam === (CHAPTERS || DEVICES)) {
      setViewMode(viewModeParam);
    }
    if (filterByParam && findFilterByOption(filterByParam)) {
      setFilterBy(findFilterByOption(filterByParam));
    }
  }, []);
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
};

export default QueryParamsControls;
